'use client'

import { useRef, useState } from "react"
import Button from "@/components/button/Button"
import Icon from "@/components/icon/Icon"
import PanelHeader from "@/components/panel/PanelHeader"
import PanelTitle from "@/components/panel/PanelTitle"
import StackedPanel from "@/components/panel/StackedPanel"
import Slideout from "@/components/slideout/Slideout"
import PanelBody from "@/components/panel/PanelBody"
import TradeForm from "./TradeForm"
import useEventListener from "@/components/plugins/EventListener"

export default function TradeSlideout(props) {
  
  const slide = useRef()
  const [launchData,setLaunchData] = useState({})
  
  useEventListener("show_trade_slide", event => {
    slide.current.toggle()
    setLaunchData(event.detail || {})
  })
  
  if (!props.site.trade) return null
  
  return <Slideout ref={slide}>
    <StackedPanel>
      <PanelHeader>
        <PanelTitle leftPad={true} centered={true}>
          <h2>{ launchData.title || "Value Your Trade" }</h2>
        </PanelTitle>
        <div>
          <Button theme={'icon'} onClick={e => slide.current.toggle()} label={ 'Close' }>
            <Icon {...props} name="x"></Icon>
          </Button>
        </div>
      </PanelHeader>
      <PanelBody padded={true}>
        <TradeForm {...props} theme="plain" close={e => slide.current.toggle()}></TradeForm>
      </PanelBody>
    </StackedPanel>
  </Slideout>
  
}